import React from "react"
import { BrowserRouter as Router } from "react-router-dom"
import { Footer } from "./components"
import RouterView from "./router"
import { LangProvider } from "./LangProvider"
import UIkit from "uikit"
import Icons from "uikit/dist/js/uikit-icons"

import "leaflet/dist/leaflet.css"

UIkit.use(Icons)

function App() {
  return (
    <LangProvider>
      <Router>
        <div>
          <RouterView></RouterView>
          <Footer />
        </div>
      </Router>
    </LangProvider>
  )
}

export default App
